import { forwardRef, Ref } from 'react';

import { muiTooltipClasses, Props, StyledTooltip } from './styles';

export { muiTooltipClasses as tooltipClasses };
export type { Props };

const Tooltip = (
  { arrow = true, disableInteractive = true, placement = 'top', ...props }: Props,
  ref: Ref<HTMLDivElement>
) => {
  return (
    <StyledTooltip
      ref={ref}
      arrow={arrow}
      {...props}
      disableInteractive={disableInteractive}
      placement={placement}
    >
      {props.children}
    </StyledTooltip>
  );
};

export default forwardRef(Tooltip);
